module.exports = __webpack_public_path__ + "img/LV1.1aa3a2f1.webp";